import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from './loader';
import { ConstantService } from './constant.service';
import { HttpClient } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class ApiService {
    constructor(private constant: ConstantService, private http: HttpClient) { }

    addData(table, payload) {
        return this.http.post(this.constant.BASE_URL + this.constant.CONTROLLERS + table + '/', payload);
    }

    updateDetail(table, key, id, payload) {
        return this.http.put(this.constant.BASE_URL + this.constant.CONTROLLERS + table + '/'+ key +'/'+ id + '/', payload);
    }
    getDetail(table, key, id) {
        return this.http.get(this.constant.BASE_URL + this.constant.CONTROLLERS + table + '/'+ key +'/'+ id + '/');
    }
    deleteDetail(table, key, id) {
        
        let idsArray = '('+id.join(',')+ ')';
        console.log(idsArray);
        return this.http.delete(this.constant.BASE_URL + this.constant.CONTROLLERS + table + '/'+ key +'/'+ btoa(idsArray) + '/');
    }
    getCustomData(string) {
        return this.http.get(this.constant.BASE_URL + this.constant.CUSTOM_REPORT + string + '/');
    }
    getCustomDataSubs(string) {
        return new Promise((resolve, reject) => {
        return this.http.get(this.constant.BASE_URL + this.constant.CUSTOM_REPORT + string + '/').subscribe((resp) => {
            resolve(resp);
        })
    });
    }

    getData(table) {
        return new Promise((resolve, reject) => {
            this.http.get(this.constant.BASE_URL + this.constant.CONTROLLERS + table + '/').subscribe((resp) => {
                resolve(resp);
            })
        });
    }

    addBulkData(table, payload) {
        return this.http.post(this.constant.BASE_URL + this.constant.CONTROLLERS + table + '/true/', payload);
    }
    
}